import { formatCompact, formatSigned, type PositionPnl } from "@axiome/counter-lp-sdk";

export function PnlCard(props: {
  pnl: PositionPnl;
  onClaim?: () => void;
  onWithdraw?: () => void;
}) {
  const p = props.pnl;
  const pos = p.pnlValueAxm >= 0;
  const maxBar = Math.max(p.depositedValueAxm, p.currentValueAxm, 1);
  const depPct = Math.min(100, (p.depositedValueAxm / maxBar) * 100);
  const curPct = Math.min(100, (p.currentValueAxm / maxBar) * 100);

  return (
    <div className="pnl-card">
      <div className="pnl-head">
        <div>
          <div className="pool-title">{p.symbol}/AXM</div>
          <div className="pnl-sub">
            Оценка вывода в AXM по данным сети. LP-токены хранятся в смартконтракте, не на
            вашем кошельке.
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div className={`pnl-value ${pos ? "pos" : "neg"}`}>
            {formatSigned(p.pnlValueAxm)} AXM
          </div>
          <div className={`pnl-sub ${pos ? "pos" : "neg"}`} style={{ color: pos ? "var(--ok)" : "var(--danger)" }}>
            {formatSigned(p.pnlValuePct, 1)}%
          </div>
        </div>
      </div>

      <div className="bars">
        <div className="bar-row">
          <label>
            <span>Внесено</span>
            <span>{formatCompact(p.depositedValueAxm)} AXM</span>
          </label>
          <div className="bar-track">
            <div className="bar-dep" style={{ width: `${depPct}%` }} />
          </div>
        </div>
        <div className="bar-row">
          <label>
            <span>Сейчас</span>
            <span>{formatCompact(p.currentValueAxm)} AXM</span>
          </label>
          <div className="bar-track">
            <div className="bar-cur" style={{ width: `${curPct}%` }} />
          </div>
        </div>
      </div>

      <div className="asset-split">
        <div>
          <div className="lbl">AXM (ваше)</div>
          <div className="nums">
            {formatCompact(p.depositedAxm)} → {formatCompact(p.currentAxm)}
          </div>
          <div className={`delta ${p.pnlAxm >= 0 ? "pos" : "neg"}`}>
            {formatSigned(p.pnlAxm)} AXM
          </div>
        </div>
        <div>
          <div className="lbl">{p.symbol} (claim / matched)</div>
          <div className="nums">
            claim {formatCompact(p.currentToken)} · matched {formatCompact(p.depositedToken)}
          </div>
          <div className="delta" style={{ color: "var(--muted)" }}>
            matched → платформе; claimable токен — через Claim
          </div>
        </div>
      </div>

      {(props.onClaim || props.onWithdraw) && (
        <div className="cta-row">
          {props.onClaim ? (
            <button className="btn btn-primary btn-sm" onClick={props.onClaim}>
              Получить доход
            </button>
          ) : null}
          {props.onWithdraw ? (
            <button className="btn btn-ghost btn-sm" onClick={props.onWithdraw}>
              Вывести
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}
